<template>
  <div data-testid="SimulationsModule">
    <router-view v-if="moduleIsReady" />
    <div v-else>Loading Panel...</div>
  </div>
</template>

<script lang="ts">
import { Vue, Prop } from 'vue-property-decorator';

export default class SimulationsModule extends Vue {
  created() {
    this.bootstrap();
  }

  get moduleIsReady() {
    return true;
  }

  bootstrap() {
  }
}
</script>
